module.exports = __webpack_public_path__ + "static/img/8.8b4383d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/8.png
// module id = 8S9/
// module chunks = 0